module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isShare) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'topicColumnDetail',
        params: {
          discussID: _vm.topicItem.discussID
        }
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "listHead"
    }
  }, [_c('div', {
    staticClass: "listHead"
  }, [_c('div', {
    staticClass: "listHead_left"
  }, [(_vm.topicItem.faceUrl !== '' && _vm.topicItem.faceUrl && _vm.topicItem.faceUrl.length > 0) ? _c('div', {
    staticClass: "listHead_img",
    style: ({
      backgroundImage: ("url(" + (_vm.topicItem.faceUrl && _vm.topicItem.faceUrl.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com')) + ")")
    })
  }) : _vm._e(), _vm._v(" "), (_vm.topicItem.faceUrl === '') ? _c('div', {
    staticClass: "listHead_img1"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "listHead_name"
  }, [_c('p', {
    staticClass: "themeColor",
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicItem.nickName || '缺少昵称'))
    }
  }), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm._f("parseDateTime")(_vm.topicItem.createTime)))])])])])])]) : _c('div', [_c('div', {
    attrs: {
      "id": "listHead1"
    }
  }, [_c('div', {
    staticClass: "listHead"
  }, [_c('div', {
    staticClass: "listHead_left"
  }, [(_vm.topicItem.faceUrl !== '' && _vm.topicItem.faceUrl && _vm.topicItem.faceUrl.length > 0) ? _c('div', {
    staticClass: "listHead_img",
    style: ({
      backgroundImage: ("url(" + (_vm.topicItem.faceUrl && _vm.topicItem.faceUrl.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com')) + ")")
    })
  }) : _vm._e(), _vm._v(" "), (_vm.topicItem.faceUrl === '') ? _c('div', {
    staticClass: "listHead_img1"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "listHead_name"
  }, [_c('p', {
    staticClass: "themeColor",
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.topicItem.nickName || '缺少昵称'))
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("parseDateTime")(_vm.topicItem.createTime)))])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4223904f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topic/listhead.vue
// module id = 294
// module chunks = 1